module.exports = __webpack_public_path__ + "img/wg-packaging.530897a4.jpg";